module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/plant.f2b82478.png";